export const SELECT_JOB_TEMPLATE = 'select_job_template'
export const SELECT_RECENT_JOB = 'select_recent_job'
